import imageCompression from "browser-image-compression";

export const compressImage = async (file) => {
  if (!file) return null;

  const options = {
    maxSizeMB: 0.25,          // حدود 250KB
    maxWidthOrHeight: 1200,   // بیشتر لازم نیست
    useWebWorker: true,
    initialQuality: 0.8,
  };

  try {
    const compressedFile = await imageCompression(file, options);

    return compressedFile;
  } catch (err) {
    console.error(err);
    return file;
  }
};